import React, { useEffect, useState } from "react";
import isNumber from "../../helpers/isNumber.helper";
import { connectOddbutton } from "./oddbutton.connect";
import { getCurrencyFormat } from "../../helpers/getCurrencyFormat.helper";

const OddButton = connectOddbutton()(
  ({
    market,
    auth,
    oddData,
    balanceSettings,
    isBack,
    betPlacing,
    oneClick,
    actions,
    showBlock = true,
    showEmpty = false,
    centered = false,
    mainBlock = true,
    isFancy = false,
    marketNum,
    setClicked,
    clicked,
    isInactive = false,
    sportLimits,
  }) => {
    // isFancy && console.log("oddData", oddData)
    const [odd, setOdd] = useState(null);
    const [isChanged, setIsChanged] = useState(false);
    const [color, setColor] = useState("");

    const getBtnActive = () => {
      const isNotActive = isBtnNotActive()
        ? " opacity-50 cursor-not-allowed "
        : " opacity-100 cursor-pointer active:scale-95 ";
      const active =
        !isNotActive &&
        betPlacing.market === (market && market.id) &&
        betPlacing.runner ===
          (oddData && oddData.runner && oddData.runner.id) &&
        betPlacing.isBack === isBack &&
        marketNum === clicked
          ? "active"
          : "";
      return `${isNotActive} ${active} `;
    };

    useEffect(() => {
      const isNotActive = isBtnNotActive() ? "not-active" : "";
      const active =
        !isNotActive &&
        betPlacing.market === (market && market.id) &&
        betPlacing.runner ===
          (oddData && oddData.runner && oddData.runner.id) &&
        betPlacing.isBack === isBack &&
        marketNum === clicked
          ? "active"
          : "";

      if (
        active &&
        betPlacing.priceActual !== (oddData && oddData.price) &&
        (betPlacing.marketType == "MATCH_ODDS" ||
          betPlacing.marketType == "MATCH_ODDS" ||
          betPlacing.marketType == "SESSION")
      ) {
        actions.setPriceActual(oddData && oddData.price);
      }
    }, [betPlacing?.priceActual, oddData?.price]);

    const isBtnNotActive = () => {
      // console.log("notAcrive func")

      if (isFancy) {
        // console.log("Status: ", market?.marketBook?.status);

        return market?.is_active !== 1 || isInactive;
        // market?.marketBook?.statusLabel !== "OPEN" ||
        // market?.marketBook?.statusLabel === 'SUSPENDED';
      } else {
        return (
          market?.status !== "OPEN" ||
          !oddData?.runner?.status ||
          !oddData?.runner?.status === "SUSPENDED" ||
          isInactive
        );
      }

      // return !market?.isBettable || !isNumber(odd?.price);
    };

    const getOddPrice = (oddData = odd) => {
      const price = oddData && oddData.price;
      return price;
    };

    const getPriseFor_SB = (marketId) => {
      return marketId && marketId.slice(marketId.length - 3) === "_SB"
        ? ((odd?.price - 1) * 100).toFixed(2).replace(".00", "")
        : odd?.price;
    };

    const getOddVolume = () => {
      const size = odd && odd.size;
      const volumeMultiplier =
        (market &&
          balanceSettings &&
          balanceSettings.settings &&
          balanceSettings.settings[market.eventTypeId] &&
          balanceSettings.settings[market.eventTypeId].volumeMultiplier) ||
        1;
      // if (!size || !volumeMultiplier || market.mtype === 'MATCH_ODDS_SB') {
      //     return;
      // }
      if (!size) {
        return;
      }
      if (market?.id?.includes("_BR")) {
        return null;
      }
      if (market?.mtype && market?.mtype === "MATCH_ODDS_SB") {
        return;
      }
      const resultVolume = Math.ceil(size * volumeMultiplier);
      return (
        <div className="odd-button__volume">
          {resultVolume >= 500000
            ? "500.000+"
            : oddData?.category === 4
            ? "--"
            : getCurrencyFormat(resultVolume)}
        </div>
      );
    };

    const getFancyOddVolume = () => {
      const size = oddData && (isBack ? oddData.BackSize1 : oddData.LaySize1);
      const volumeMultiplier =
        (market &&
          balanceSettings &&
          balanceSettings.settings &&
          balanceSettings.settings[market.eventTypeId] &&
          balanceSettings.settings[market.eventTypeId].volumeMultiplier) ||
        1;
      // if (!size || !volumeMultiplier || market.mtype === 'MATCH_ODDS_SB') {
      //     return;
      // }
      if (!size) {
        return;
      }
      if (market?.id?.includes("_BR")) {
        return null;
      }
      if (market?.mtype && market?.mtype === "MATCH_ODDS_SB") {
        return;
      }
      const resultVolume = Math.ceil(size * volumeMultiplier);
      return (
        <div className="odd-button__volume">
          {resultVolume >= 500000
            ? "500.000+"
            : oddData?.category === 4
            ? "--"
            : getCurrencyFormat(resultVolume)}
        </div>
      );
    };

    const select = () => {
      let marketId;
      let runnerId;
      let limits;
      if (isFancy) {
        marketId = market && market.fancy_id;
        runnerId = market && market.selection_id;
        limits =
          sportLimits &&
          sportLimits?.data &&
          sportLimits?.data?.session &&
          sportLimits?.data?.session[marketId];
      } else {
        marketId = market && market.market_id;
        runnerId =
          (oddData && oddData.runner && oddData.runner.id) ||
          oddData.selectionId;
        limits =
          sportLimits && sportLimits?.data && sportLimits?.data[marketId];
      }
      if (!marketId || !runnerId) return;
      actions.setMarket(marketId);
      actions.setMarketName(market && market?.market_name);
      actions.setMarketType(market && market?.market_type);
      actions.setRunner(
        isFancy ? (isBack ? oddData?.BackSize1 : oddData?.LaySize1) : runnerId
      );
      actions.setRunnerName(oddData && oddData.runner && oddData.runner.name);
      actions.setEventName(market && market.market_name);
      actions.setEventId(market && market?.match_id);
      actions.setIsBack(isBack);
      actions.setPrice(
        isFancy
          ? isBack
            ? oddData?.BackPrice1
            : oddData?.LayPrice1
          : oddData.price
      );
      actions.setPriceActual(
        isFancy
          ? isBack
            ? oddData?.BackPrice1
            : oddData?.LayPrice1
          : oddData.price
      );
      actions.setDelay(market && market.betDelay);
      actions.setMtype(market && market.mtype);
      actions.setBtype(market && market.btype);
      actions.setLine(isFancy);
      actions.setStartTime(market && market?.match_date);
      actions.setEventTypeId(market && market.eventTypeId);
      actions.setIsCashOut(false);
      //TODO: add market limits betslip
      actions.setMaxBet(
        (limits && limits.market_max_stack) ||
          (limits && limits.session_max_stack)
      );
      actions.setMinBet(
        (limits && limits.market_min_stack) ||
          (limits && limits.session_min_stack)
      );
      actions.setMarketAll(market);
      //   setMinMaxAll
      if (oneClick.active) {
        actions.setStake(oneClick.settings[oneClick.selected - 1]);
        actions.setBetPlacingPopoverStage(false);
        actions.setShowBetPlacingPopover(true);
        actions.setFromOneClick(true);
      } else {
        actions.setFromOneClick(false);
        // actions.setStake(null)
      }
      if (auth) {
        // actions.requestBetPlacingStart(marketId, runnerId)
        //     .then((response) => {
        //     })
        //     .catch((err) => console.log('err = ', err))
      }
    };

    const select12 = () => {
      const marketId =
        market && market?.market_id
          ? market?.market_id
          : market?.marketBook?.market_id;
      const runnerId = oddData && oddData.runner && oddData.runner.id;

      // console.log("Market: ", market);
      // console.log("Market Id: ", marketId);
      // console.log("Runner Id: ", runnerId);

      // const runnerName = oddData && oddData.runner && oddData.runner.name;
      // console.log("Runner Name: ", runnerName);
      // console.log("Event Name: ", market && market?.eventName);
      // console.log("Is Back: ", isBack);
      // console.log("Price: ", oddData && oddData.price);
      // console.log("Price: ", oddData && oddData.price);
      // console.log("Bet Delay: ", ((market && market?.marketBook && market?.marketBook?.betDelay) || 0 ))
      // console.log("Event Type Id: ", market && market?.eventTypeId)
      // console.log("Market Type: ", market && market?.marketType);
      if (!marketId || !oddData.runner) return;
      actions.setMarket(marketId);
      actions.setMarketType(market && market?.marketType);
      actions.setMarketName(market && market?.market_name);
      actions.setRunner(runnerId);
      actions.setRunnerName(oddData && oddData.runner && oddData.runner.name);
      // actions.setEventName(market && market?.event && market.event.name)
      actions.setEventName(market && market?.match_name);
      actions.setEventId(market && market?.match_id);
      actions.setIsBack(isBack);
      actions.setPrice(oddData && oddData.price);
      actions.setPriceActual(oddData && oddData.price);
      actions.setIsCashOut(false);

      if (market?.marketType == "SESSION") {
        actions.setFancyPrice(oddData && oddData.size);
      }

      // actions.setDelay(market && market.betDelay)
      actions.setDelay(
        (market && market?.marketBook && market?.marketBook?.betDelay) || 0
      );
      actions.setMtype(market && market?.mtype);
      actions.setBtype(market && market?.btype);
      actions.setLine(oddData && oddData?.line);
      // actions.setStartTime(market && market?.start)
      actions.setStartTime(market && market?.match_date);
      actions.setEventTypeId(market && market?.sport_id);
      if (oneClick.active) {
        actions.setStake(oneClick.settings[oneClick.selected - 1]);
        actions.setBetPlacingPopoverStage(false);
        actions.setShowBetPlacingPopover(true);
        actions.setFromOneClick(true);
      } else {
        actions.setFromOneClick(false);
        // actions.setStake(null)
      }
      if (auth) {
        // actions.requestBetPlacingStart(marketId, runnerId)
        // .then((response) => {
        // })
        // .catch((err) => console.log('err = ', err))
      }
    };

    useEffect(() => {
      if (isDataChanged()) {
        setIsChanged(true);
        setTimeout(() => {
          setIsChanged(false);
        }, 300);
        setOdd(oddData);
      }
    }, [oddData?.price, oddData?.size]);

    useEffect(() => {
      setColor(isBack ? `back-color` : `lay-color`);
    }, [isBack]);

    const isDataChanged = () => {
      return (
        getOddPrice() !== getOddPrice(oddData) || odd?.size !== oddData?.size
      );
    };

    return (
      <>
        <span
          className="flex items-center justify-center w-full h-full p-[1px]  overflow-hidden"
          // className="flex items-center justify-center w-full h-full  overflow-hidden"
          onClick={() => {
            if (
              !isBtnNotActive() &&
              oddData &&
              (isFancy
                ? isBack
                  ? oddData?.BackPrice1
                  : oddData?.category !== 4 && oddData?.LayPrice1
                : oddData.price) > 0
            ) {
              setClicked && setClicked(marketNum);
              select();
            }
          }}
        >
          <div
            className={` overflow-hidden relative   ${getBtnActive()} w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center ${
              isBack
                ? "bg-bg_BackBtnBg border border-backBtn"
                : "bg-bg_LayBtnBg border border-layBtn"
            }  undefined`}
          >
            <span
              id="oddBtnPrice"
              className="relative z-10 transition-all ease-in-out duration-300 origin-center flex items-center justify-center w-full text-text_OddValue leading-5 text-sm md:text-[15px] font-semibold "
            >
              {isFancy
                ? isNumber(
                    Number(
                      isBack
                        ? oddData?.BackPrice1
                        : oddData?.category === 4
                        ? "--"
                        : oddData?.LayPrice1
                    )
                  ) &&
                  !!oddData &&
                  (isBack ? oddData?.BackPrice1 : oddData?.LayPrice1)
                : isNumber(Number(odd?.price)) &&
                  (odd?.price === 0 || !odd?.price)
                ? "-"
                : isNumber(Number(odd?.price))
                ? getCurrencyFormat(getPriseFor_SB(market && market.id))
                : showEmpty
                ? "-"
                : "-"}
            </span>
            <span
              id="oddBtnSize"
              className=" relative z-10 transition-all ease-in-out duration-300 origin-center flex items-center justify-center w-full text-[10px] text-text_OddValue leading-3 text-center whitespace-normal font-normal "
            >
              <span className="w-max break-all truncate">
                {isFancy
                  ? isNumber(
                      Number(
                        isBack
                          ? oddData?.BackPrice1
                          : oddData?.category === 4
                          ? "--"
                          : oddData?.LayPrice1
                      )
                    ) &&
                    (isBack ? oddData?.BackPrice1 : oddData?.LayPrice1) === 0
                    ? "-"
                    : isNumber(
                        Number(
                          isBack ? oddData?.BackPrice1 : oddData?.LayPrice1
                        )
                      )
                    ? getFancyOddVolume()
                    : ""
                  : isNumber(Number(odd?.price)) && odd?.price === 0
                  ? "-"
                  : isNumber(Number(odd?.price))
                  ? getOddVolume()
                  : ""}
              </span>
            </span>
            {isChanged && (
              <span className="absolute top-0 left-0 w-full h-full highLightChange"></span>
            )}
          </div>
        </span>
      </>
    );
  }
);

export default OddButton;
